import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShowMoreDirective } from './show-more.directive';

@NgModule({
  declarations: [
    ShowMoreDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ShowMoreDirective
  ]
})
export class ShowMoreModule { }
